<!-- Container -->
<div class="container">

  <ul>
    <li>
      Once your account is created, you will stay logged in until you actively log out.
    </li>

    <li class="img-to-text">
      When you open the app, you will arrive at the main screen.
    </li>


      The main menu lists all your sets


        <!-- main_menu.png -->
        <img [src]="getImgs[0]"
             class="help-img"
             (click)="showImage(getImgs[0])" />
      


    <br>
    <li class="img-to-text">
      The menu in the top right has links to your completed deliveries, help, profile, and settings pages.

      <div class="row">
        <!-- main_menu.png -->
        <img [src]="getImgs[1]"
             class="help-img"
             (click)="showImage(getImgs[1])" />
      </div>

    </li>


  </ul>

</div>
